import { render, staticRenderFns } from "./LoginMobile.vue?vue&type=template&id=3b964204&scoped=true&"
import script from "./LoginMobile.ts?vue&type=script&lang=ts&"
export * from "./LoginMobile.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b964204",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b964204')) {
      api.createRecord('3b964204', component.options)
    } else {
      api.reload('3b964204', component.options)
    }
    module.hot.accept("./LoginMobile.vue?vue&type=template&id=3b964204&scoped=true&", function () {
      api.rerender('3b964204', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/typo3conf/ext/aus_project/Resources/Private/TypeScript/LoginStatus/Components/LoginMobile/LoginMobile.vue"
export default component.exports